export default __webpack_public_path__ + "images/b7738d6026fb8af08e34b630af09327b.svg";